<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> Projects Graphics
                    </div>
                    <div class="card-block">
                        <div>
                            <h3 class="text-center">Logged hours (last 6 months)</h3>
                            <div id="eventdrops-logged-graph" style="width: 100%; background: #eee;"></div>
                        </div>
                    </div>
                    <div class="card-block">
                        <div>
                            <h3 class="text-center">Planned hours (next 6 months)</h3>
                            <div id="eventdrops-planned-graph" style="width: 100%; background: #eee;"></div>
                        </div>
                    </div>
                    <div class="card-block" v-if="!projectId">
                        <div>
                            <h3 class="text-center">Planned hours by user (next 6 months)</h3>
                            <div id="eventdrops-planned-graph-by-user" style="width: 100%; background: #eee;"></div>
                        </div>
                    </div>
                    <div class="card-block">
                        <h3 class="text-center">All logged hours by user per project (percentage)</h3>
                        <div id="gchart" class="width: 100%">
                            <GChart
                                    type="BarChart"
                                    :data="chartData"
                                    ref="gChart"
                                    :options="chartOptions"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as d3 from 'd3';
import eventDrops from 'event-drops';
import moment from 'moment';
import { GChart } from 'vue-google-charts';

export default {
  name: 'ProjectGraphics',
  components: {
    GChart
  },
  props: {
    projectId: {
      default: null
    }
  },
  data: function () {
    return {
      chartData: [],
      chartOptions: {
        bar: { groupWidth: '75%' },
        isStacked: 'percent',
        legend: { position: 'top', maxLines: 5 },
        width: '100%',
        //                    height: this.chartData.length * 10,
        //                    vAxis: {
        //                        minValue: 0,
        //                        ticks: [0, .3, .6, .9, 1]
        //                    },
        focusTarget: true,
        chartArea: {
          left: 50,
          top: 100,
          width: '100%',

        },
      },
      colors: ['aqua', 'black', 'blue', 'fuchsia', 'gray', 'green',
        'lime', 'maroon', 'navy', 'olive', 'orange', 'purple', 'red',
        'silver', 'teal', 'yellow', '#BA4A00', '#E74C3C', '#2C3E50',
        '#AF7AC5', '#48C9B0', '#7D6608', '#17202A', '#BB8FCE']
    };
  },
  watch: {
    users: function () {
      //                console.log(this.users);
    },
    allProjectsWithLoggedHoursByUsers: 'allProjectsGraph',
    loggedHoursByProject: 'createEventDropsGraphWorkedHours',
    plannedHoursByProject: 'createEventDropsGraphPlannedHours',
    plannedHoursByUser: 'createEventDropsGraphPlannedHoursByUser'
  },
  computed: {
    ...mapGetters('JiraUsers', ['users']),
    ...mapGetters('ProjectGraphics', [
      'allProjectsWithLoggedHoursByUsers',
      'loggedHoursByProject',
      'plannedHoursByProject',
      'plannedHoursByUser'
    ])
  },
  methods: {
    ...mapActions('JiraUsers', ['LOAD_JIRA_USERS']),
    ...mapActions('ProjectGraphics', [
      'GET_ALL_PROJECTS_WITH_LOGGED_HOURS',
      'GET_LOGGED_HOURS_BY_PROJECT',
      'GET_PLANNED_HOURS_BY_PROJECT',
      'GET_PLANNED_HOURS_BY_USER'
    ]),
    allProjectsGraph() {
      let projects = [];
      if (this.projectId) {
        for (var i in this.allProjectsWithLoggedHoursByUsers) {
          if (this.allProjectsWithLoggedHoursByUsers[i].id == this.projectId) {
            projects.push(this.allProjectsWithLoggedHoursByUsers[i]);
            this.chartOptions.focusTarget = 'category';
            this.chartOptions.height = 200;
            break;
          }
        }
      } else {
        projects = this.allProjectsWithLoggedHoursByUsers;
        this.chartOptions.height = projects.length * 30;
      }
      const data = [];
      data[0] = [];
      data[0][0] = 'User';
      for (var proj in projects) {
        var hoursByUser = projects[proj].loggedHoursByUser;
        var projectData = [];
        projectData.push(projects[proj].key);
        // add all users in projects
        for (var user in hoursByUser) {
          let userInArray = false;
          for (let j = 0; j < data[0].length; j++) {
            if (data[0][j] == hoursByUser[user].user_name) {
              userInArray = true;
            }
          }
          if (!userInArray) {
            data[0].push(hoursByUser[user].user_name);
          }
        }
      }
      for (var proj in projects) {
        var projectData = [];
        projectData.push(projects[proj].key);
        // fill all array with nulls
        for (var i = 1; i < data[0].length; i++) {
          projectData.push(null);
        }
        var hoursByUser = projects[proj].loggedHoursByUser;
        // fill array with logged hours
        for (var user in hoursByUser) {
          for (var i = 1; i < data[0].length; i++) {
            if (data[0][i] == hoursByUser[user].user_name) {
              projectData[i] = hoursByUser[user].hours_sum;
            }
          }
        }
        data.push(projectData);
      }
      this.chartData = data;
    },
    createEventDropsGraphWorkedHours() {
      let loggedHoursByProject = [];
      if (this.projectId) {
        for (var i in this.loggedHoursByProject) {
          if (this.loggedHoursByProject[i].id == this.projectId) {
            loggedHoursByProject.push(this.loggedHoursByProject[i]);
            break;
          }
        }
      } else {
        loggedHoursByProject = this.loggedHoursByProject;
      }

      const chartData = [];
      for (const proj in loggedHoursByProject) {
        const color = this.colors[Math.floor(Math.random() * this.colors.length)];
        const project = {
          name: loggedHoursByProject[proj].name,
          data: [],
          color: color
        };

        const weeks = loggedHoursByProject[proj].loggedHours;
        for (const week in weeks) {
          const hoursInWeek = 168;
          const loggedHoursInWeek = Math.round(weeks[week].time_spent_seconds / 1800);
          const gap = hoursInWeek / loggedHoursInWeek;
          let date = new Date(weeks[week].date);
          date.setHours(0, 0, 0, 0); // set date hours to 00:00
          for (var i = 0; i < loggedHoursInWeek; i++) {
            const projectWeekData = {
              date: moment(date).format('YYYY/MM/DD, HH:mm:ss'),
              tooltipValue: weeks[week].time_spent_seconds / 3600,
              yearweek: week,
              color: color,
              radius: Math.sqrt(weeks[week].time_spent_seconds / 3600) * 0.7,
              dateFromDateTo: `${moment(new Date(weeks[week].date)).startOf('isoWeek').format('YYYY-MM-DD') 
              } - ${moment(new Date(weeks[week].date)).endOf('isoWeek').format('YYYY-MM-DD')}`,
            };
            date = moment(date).add(gap, 'hours').format('YYYY/MM/DD, HH:mm:ss');
            project.data.push(projectWeekData);
          }
        }
        chartData.push(project);
      }

      const tooltip = d3.select('body').append('div').attr('class', 'tooltip').style('opacity', 0);
      const chart = eventDrops({ d3,
        label: {
          padding: 5,
          text: (d) => d.name,
          width: 200,
        },
        drop: {
          date: (d, index) => new Date(d.date),
          radius: (d, index) => d.radius,
          color: (d, index) => d.color,
          onMouseOver: ('mouseover', function (d) {
            tooltip.transition().duration(200).style('opacity', 1).style('pointer-events', 'auto');
            tooltip.html(`
                                <div style="background: #fff; border: 3px solid #e7e7e7; border-radius: 15px; padding: 5px;">
                                    <p style="margin-bottom: 5px;">Year/Week: ${d.yearweek}</p>
                                    <p style="margin-bottom: 5px;">Hours: ${d.tooltipValue}</p>
                                    <p style="margin-bottom: 5px;">Period: ${d.dateFromDateTo}</p>
                                </div>`)
              .style('left', `${d3.event.pageX - 200}px`)
              .style('top', `${d3.event.pageY + 20}px`);
          }),
          onMouseOut: () => {
            tooltip.transition().duration(500).style('opacity', 0).style('pointer-events', 'none');
          },
        },
        line: {
          height: 40,
          color: (line, index) => line.color,
        },
        range: {
          start: new Date(new Date().getTime() - 3600000 * 24 * 183), // six months ago
          end: new Date(),
        },
        axis: {
          formats: {
            //                            milliseconds: '',
            //                            seconds: '',
            //                            minutes: '',
            //                            hours: '',
            //                            days: '%a %d',
            milliseconds: '%L',
            seconds: ':%S',
            minutes: '%I:%M',
            hours: '%I %p',
            days: '%a %d',
            weeks: '%V',
            months: '%B',
            year: '%Y',
          }
        },
        zoom: false,
      });

      d3.select('#eventdrops-logged-graph').data([chartData]).call(chart);
    },
    createEventDropsGraphPlannedHours() {
      let plannedHoursByProject = [];
      if (this.projectId) {
        for (var i in this.plannedHoursByProject) {
          if (this.plannedHoursByProject[i].id == this.projectId) {
            plannedHoursByProject.push(this.plannedHoursByProject[i]);
            break;
          }
        }
      } else {
        plannedHoursByProject = this.plannedHoursByProject;
      }
      const chartData = [];

      for (const proj in plannedHoursByProject) {
        if (Object.keys(plannedHoursByProject[proj].planned).length == 0) {
          continue;
        }
        const color = this.colors[Math.floor(Math.random() * this.colors.length)];
        const project = {
          name: plannedHoursByProject[proj].name,
          data: [],
          color: color
        };

        const weeks = plannedHoursByProject[proj].planned;
        for (const week in weeks) {
          const hoursInWeek = 168;
          const loggedHoursInWeek = Math.round(weeks[week].hours / 1800);
          const gap = hoursInWeek / loggedHoursInWeek;
          let date = new Date(weeks[week].date);
          date.setHours(0, 0, 0, 0); // set date hours to 00:00
          for (var i = 0; i < loggedHoursInWeek; i++) {
            const projectWeekData = {
              date: moment(date).format('YYYY/MM/DD, HH:mm:ss'),
              tooltipValue: weeks[week].hours / 3600,
              yearweek: week,
              color: color,
              radius: Math.sqrt(weeks[week].hours / 3600) * 0.7,
              dateFromDateTo: `${moment(new Date(weeks[week].date)).startOf('isoWeek').format('YYYY-MM-DD') 
              } - ${moment(new Date(weeks[week].date)).endOf('isoWeek').format('YYYY-MM-DD')}`,
            };
            date = moment(date).add(gap, 'hours').format('YYYY/MM/DD, HH:mm:ss');
            project.data.push(projectWeekData);
          }
        }
        chartData.push(project);
      }

      const tooltip = d3.select('body').append('div').attr('class', 'tooltip').style('opacity', 0);
      const chart = eventDrops({ d3,
        label: {
          padding: 5,
          text: (d) => d.name,
          width: 200,
        },
        drop: {
          date: (d, index) => new Date(d.date),
          radius: (d, index) => d.radius,
          color: (d, index) => d.color,
          onMouseOver: ('mouseover', function (d) {
            tooltip.transition().duration(200).style('opacity', 1).style('pointer-events', 'auto');
            tooltip.html(`
                                <div style="background: #fff; border: 3px solid #e7e7e7; border-radius: 15px; padding: 5px;">
                                    <p style="margin-bottom: 5px;">Year/Week: ${d.yearweek}</p>
                                    <p style="margin-bottom: 5px;">Hours: ${d.tooltipValue}</p>
                                    <p style="margin-bottom: 5px;">Period: ${d.dateFromDateTo}</p>
                                </div>`)
              .style('left', `${d3.event.pageX - 200}px`)
              .style('top', `${d3.event.pageY + 20}px`);
          }),
          onMouseOut: () => {
            tooltip.transition().duration(500).style('opacity', 0).style('pointer-events', 'none');
          },
        },
        line: {
          height: 40,
          color: (line, index) => line.color,
        },
        range: {
          start: new Date(), // six months forward
          end: new Date(new Date().getTime() + 3600000 * 24 * 183),
        },
        axis: {
          formats: {
            //                            milliseconds: '',
            //                            seconds: '',
            //                            minutes: '',
            //                            hours: '',
            //                            days: '%a %d',
            milliseconds: '%L',
            seconds: ':%S',
            minutes: '%I:%M',
            hours: '%I %p',
            days: '%a %d',
            weeks: '%V',
            months: '%B',
            year: '%Y',
          }
        },
        zoom: false,
      });

      d3.select('#eventdrops-planned-graph').data([chartData]).call(chart);
    },
    createEventDropsGraphPlannedHoursByUser() {
      if (this.projectId) {
        return;
      }
      const plannedHoursByUser = this.plannedHoursByUser;
      const chartData = [];

      for (const user in plannedHoursByUser) {
        if (Object.keys(plannedHoursByUser[user].planned).length == 0) {
          continue;
        }
        const color = this.colors[Math.floor(Math.random() * this.colors.length)];
        const userData = {
          name: plannedHoursByUser[user].displayName,
          data: [],
          color: color
        };

        const weeks = plannedHoursByUser[user].planned;
        for (const week in weeks) {
          const hoursInWeek = 168;
          const loggedHoursInWeek = Math.round(weeks[week].hours / 1800);
          const gap = hoursInWeek / loggedHoursInWeek;
          let date = new Date(weeks[week].date);
          date.setHours(0, 0, 0, 0); // set date hours to 00:00
          for (let i = 0; i < loggedHoursInWeek; i++) {
            const userWeekData = {
              date: moment(date).format('YYYY/MM/DD, HH:mm:ss'),
              tooltipValue: weeks[week].hours / 3600,
              yearweek: week,
              color: color,
              radius: Math.sqrt(weeks[week].hours / 3600) * 0.7,
              dateFromDateTo: `${moment(new Date(weeks[week].date)).startOf('isoWeek').format('YYYY-MM-DD') 
              } - ${moment(new Date(weeks[week].date)).endOf('isoWeek').format('YYYY-MM-DD')}`,
            };
            date = moment(date).add(gap, 'hours').format('YYYY/MM/DD, HH:mm:ss');
            userData.data.push(userWeekData);
          }
        }
        chartData.push(userData);
      }

      const tooltip = d3.select('body').append('div').attr('class', 'tooltip').style('opacity', 0);
      const chart = eventDrops({ d3,
        label: {
          padding: 5,
          text: (d) => d.name,
          width: 200,
        },
        drop: {
          date: (d, index) => new Date(d.date),
          radius: (d, index) => d.radius,
          color: (d, index) => d.color,
          onMouseOver: ('mouseover', function (d) {
            tooltip.transition().duration(200).style('opacity', 1).style('pointer-events', 'auto');
            tooltip.html(`
                                <div style="background: #fff; border: 3px solid #e7e7e7; border-radius: 15px; padding: 5px;">
                                    <p style="margin-bottom: 5px;">Year/Week: ${d.yearweek}</p>
                                    <p style="margin-bottom: 5px;">Hours: ${d.tooltipValue}</p>
                                    <p style="margin-bottom: 5px;">Period: ${d.dateFromDateTo}</p>
                                </div>`)
              .style('left', `${d3.event.pageX - 200}px`)
              .style('top', `${d3.event.pageY + 20}px`);
          }),
          onMouseOut: () => {
            tooltip.transition().duration(500).style('opacity', 0).style('pointer-events', 'none');
          },
        },
        line: {
          height: 40,
          color: (line, index) => line.color,
        },
        range: {
          start: new Date(), // six months forward
          end: new Date(new Date().getTime() + 3600000 * 24 * 183),
        },
        axis: {
          formats: {
            //                            milliseconds: '',
            //                            seconds: '',
            //                            minutes: '',
            //                            hours: '',
            //                            days: '%a %d',
            milliseconds: '%L',
            seconds: ':%S',
            minutes: '%I:%M',
            hours: '%I %p',
            days: '%a %d',
            weeks: '%V',
            months: '%B',
            year: '%Y',
          }
        },
        zoom: false,
      });

      d3.select('#eventdrops-planned-graph-by-user').data([chartData]).call(chart);
    }
  },
  mounted() {
    this.GET_ALL_PROJECTS_WITH_LOGGED_HOURS();
    this.GET_LOGGED_HOURS_BY_PROJECT();
    this.GET_PLANNED_HOURS_BY_PROJECT();
    this.GET_PLANNED_HOURS_BY_USER();
    this.LOAD_JIRA_USERS();
  },
};
</script>

<style lang="scss" scoped>
</style>
